import { render } from "./PhoneCodeCells.vue?vue&type=template&id=48a5c5aa&scoped=true"
import script from "./PhoneCodeCells.vue?vue&type=script&lang=js"
export * from "./PhoneCodeCells.vue?vue&type=script&lang=js"

import "./PhoneCodeCells.vue?vue&type=style&index=0&id=48a5c5aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a5c5aa"]])

export default __exports__